__turbopack_context__.v({
  "className": "open_sans_692fffa6-module__7ZPReG__className",
  "variable": "open_sans_692fffa6-module__7ZPReG__variable",
});
